import http from "./httpService";
import { reportApi } from "./config.json";
import auth from "./authService";

export async function getSalesReport(search) {
  const obj = { search };
  const { data } = await http.post(reportApi + "selectSalesReport.php", obj);
  return data;
}
export async function getDashboardReport(search) {
  const obj = { search };
  const { data } = await http.post(reportApi + "selectDashboardReport.php", obj);
  return data;
}
export async function getMarketingReport(search) {
  const obj = { search };
  const { data } = await http.post(reportApi + "selectMarketingReport.php", obj);
  return data;
}
export async function getShipmentReport(search) {
  const obj = { search };
  const { data } = await http.post(reportApi + "selectShipmentReport.php", obj);
  return data;
}

export async function getDataExportHeader(search) {
  const obj = { search };
  const { data } = await http.post(reportApi + "getDataExportHeader.php", obj);
  return data;
}
export async function getDataExportDetail(search) {
  const obj = { search };
  const { data } = await http.post(reportApi + "getDataExportDetail.php", obj);
  return data;
}

export async function getCustomerGrowthReport(search) {
  const obj = { search };
  const { data } = await http.post(reportApi + "selectCustomerGrowthReport.php", obj);
  return data;
}

export async function getMarketingGeneralReport(search) {
  const obj = { search };
  const { data } = await http.post(reportApi + "selectMarketingGeneralReport.php", obj);
  return data;
}

export async function getGeneralReportPerMarketing(search) {
  const obj = { search };
  const { data } = await http.post(reportApi + "selectGeneralReportPerMarketing.php", obj);
  return data;
}



// WEBPACK FOOTER //
// ./src/services/reportServices.js